import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import * as styles from "./landing-skeleton.module.css";

const PRODUCT_PLACEHOLDERS = ["one", "two", "three", "four", "five"];

export const LandingSkeleton = memo(function LandingSkeleton() {
  return (
    <Flex bgColor="secondary" className={styles.shell} dir="column">
      <Flex
        bgColor="primary"
        borderColor="primary"
        borderRadius="2xl"
        borderStyle="solid"
        borderWidth="1px"
        className={styles.frame}
        dir="column"
        overflow="hidden"
        shadow="lg"
      >
        <Flex
          align="center"
          as="header"
          justify="space-between"
          px="5xl"
          py="3xl"
        >
          <Flex className={styles.logoBone} />
          <Flex align="center" gap="3xl">
            <Flex className={styles.buttonBone} />
            <Flex className={styles.avatarBone} />
          </Flex>
        </Flex>
        <Flex
          className={styles.viewport}
          dir="column"
          flex={1}
          gap="5xl"
          minH="none"
        >
          <Flex dir="column" gap="md">
            <Flex className={styles.titleBone} />
            <Flex className={styles.subtitleBone} />
          </Flex>
          <Flex className={styles.pickerGrid} flex={1} gap="5xl" minH="none">
            <Flex dir="column" flex={1} gap="md">
              <Flex className={styles.sectionBone} />
              {PRODUCT_PLACEHOLDERS.map((placeholder) => (
                <Flex className={styles.productBone} key={placeholder} />
              ))}
            </Flex>
            <Flex className={styles.pitchBone} flex={1} />
          </Flex>
        </Flex>
        <Flex justify="flex-end" px="7xl" py="4xl">
          <Flex className={styles.continueBone} />
        </Flex>
      </Flex>
    </Flex>
  );
});
